import * as React from 'react';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import classNames from 'classnames';
import Icon from 'src/components/Icon';
import { IPage, PageStatus } from 'src/Entities/Pages';
import DragIcon from './DragIcon';

export interface IPageProps {
  page: IPage;
  isActive?: boolean;
  onClick?: (page: IPage) => void;
}

export interface IChildPageProps extends IPageProps {
  handleProps?: DraggableProvidedDragHandleProps;
}

const getIconNameByPage = (page: IPage) => (
  page.status === PageStatus.PUBLISHED ? 'visible' : 'invisible'
);

const getActiveClassNames = (isActive: boolean) => (
  isActive
    ? 'has-background-white z-10 relative'
    : 'has-background-gray-400 cursor-pointer has-text-gray-600'
);

export const ParentPage = ({ page, isActive, onClick }: IPageProps) => (
  <div
    className={classNames(
      'f3 font-bold py-6 px-4 flex items-center',
      getActiveClassNames(isActive === true),
    )}
    onClick={onClick ? () => onClick(page) : undefined}
  >
    <Icon name={getIconNameByPage(page)} className="mr-4" />
    {page.title}
  </div>
);

export const ChildPage = React.forwardRef<HTMLDivElement, IChildPageProps>(
  ({ page, handleProps, isActive, onClick, ...props }, ref) => (
    <div
      ref={ref}
      className="mt-2 pl-2 flex items-center"
      onClick={onClick ? () => onClick(page) : undefined}
      {...props}
    >
      <div
        {...handleProps}
        className="w-8 h-8 flex-none"
        style={{ backgroundColor: '#DCDCDC' }}
      >
        <DragIcon />
      </div>
      <div className={classNames(
        'p-4 flex-1 flex items-center font-bold',
        getActiveClassNames(isActive === true),
      )}>
        <Icon name={getIconNameByPage(page)} className="mr-4 w-5 h-5" />
        {page.status === PageStatus.DRAFTED
          ? <span className="i font-semibold">Ny kladde*</span>
          : page.title}
      </div>
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/Pages/PageEditor/components/PageListEditorPage.tsx